module.exports = __webpack_public_path__ + "static/img/circle-1.227310d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/circle-1.png
// module id = 7XRM
// module chunks = 0